import { createListFilters, IOption } from 'app/components'

export type EspecialidadeVinculosFilters = {
  /** Nome da especialidade (busca parcial). */
  especialidade: string
  empresa?: IOption<number>
  /** Depende da instituição (é limpa quando a instituição sai). */
  unidade?: IOption<number>
}

export const { ListFiltersProvider, useListFilters } =
  createListFilters<EspecialidadeVinculosFilters>({
    especialidade: '',
    empresa: undefined,
    unidade: undefined,
  })
